import { useTranslation } from "react-i18next";
import { Icon, Message, MessageContent, MessageHeader } from "semantic-ui-react";

import "modules/DealerLicenseOverview/components/InvoicingDisabledLocationsMessage/InvoicingDisabledLocationsMessage.scss";
import { useDealerLicensesDashboardFilters } from "modules/DealerLicenseOverview/hooks";

export const InvoicingDisabledLocationsMessage = () => {
  const { t } = useTranslation();

  const { dealer } = useDealerLicensesDashboardFilters();

  const invoicingDisabledLocations = dealer?.locations?.flatMap(loc => (loc.active && !loc.is_exact_invoicing_enabled ? [loc.name] : [])).join(", ") ?? "";
  if (!invoicingDisabledLocations) return null;

  return (
    <div className="InvoicingDisabledLocationsMessage">
      <Message icon className="message-container">
        <div className="icon-placement">
          <Icon className="exclamation triangle red" size="big" />
        </div>
        <MessageContent>
          <MessageHeader>
            <span className="header-title">{t("v8_the_following_locations_dont_have_invoicing_enabled", "The following locations don't have invoicing enabled")}:</span>
          </MessageHeader>
          <span className="header-text">{invoicingDisabledLocations}</span>
        </MessageContent>
      </Message>
    </div>
  );
};
